'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MetisMenu = require('./components/MetisMenu');

var _MetisMenu2 = _interopRequireDefault(_MetisMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MetisMenu2.default; /**
                                        * src/main.js
                                        * Author: H.Alper Tuna <halpertuna@gmail.com>
                                        * Date: 16.09.2016
                                        */


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-metismenu/lib/index.js
 ** module id = 721
 ** module chunks = 0
 **/